var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',[_vm._t("icon"),_c('h2',{class:_vm.isDark ? 'dark-header' : 'light-header'},[_vm._v(_vm._s(_vm.title))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }